export default __webpack_public_path__ + "assets/images/decor.46cbdd.png";